export default {
  nav: {
    home: 'Inicio',
    shoppingGuide: 'Guía de Compra',
    guide: 'Guía de la Spreadsheet',
    categories: 'Categorías',
    buyNow: 'Comprar Ahora',
    language: 'Idioma',
  },
  hero: {
    badge: 'Recurso Independiente · Actualizado · Enfocado en Seguridad',
    title: 'USFans Spreadsheet — Encuentra Vendedores, Productos y Recursos',
    subtitle:
      'Explora los recursos más recientes de la USFans spreadsheet, listas de vendedores, guías de productos, información QC, consejos de envío, reseñas y recursos de seguridad, todo en un solo lugar.',
    cta1: 'USFans Spreadsheet',
    cta2: 'Comprar Ahora',
    trust: 'Recurso Independiente · Actualizado · Enfocado en Seguridad',
    disclaimer:
      'USFansSheet.link es un recurso informativo independiente y no está necesariamente afiliado con USFans. Verifica siempre la información importante antes de comprar.',
    cardTitle: 'Vista Previa de la Spreadsheet',
    cardSeller: 'Vendedor',
    cardProduct: 'Producto',
    cardCategory: 'Categoría',
    cardQc: 'QC',
    cardShipping: 'Envío',
    cardStatus: 'Estado',
    cardUpdated: 'Actualizado',
  },
  categorySection: {
    title: 'Explora las Categorías de Productos',
    subtitle:
      'Ve directo a la categoría que buscas. Cada enlace abre la sección correspondiente en el sitio web principal.',
    dropdownLabel: 'Elige una categoría',
    allCategories: 'Todas las categorías',
    goTo: 'Abrir categoría',
  },
  about: {
    title: '¿Qué es una USFans Spreadsheet?',
    subtitle:
      'Una forma organizada de descubrir productos, vendedores y recursos de compra sin buscar entre información dispersa.',
    p1: 'Una USFans spreadsheet es una forma estructurada de descubrir productos, vendedores y recursos útiles de compra sin buscar entre información dispersa. Nuestro hub de USFans Spreadsheet organiza la información de vendedores, las categorías de productos, los recursos QC, las guías de envío y la información relacionada en un formato más fácil de usar.',
    p2: 'Ya sea que busques zapatos, sudaderas, camisetas, bolsos o accesorios, puedes empezar aquí y continuar al sitio web principal para ver el catálogo completo.',
    cta: 'Explora la USFans Spreadsheet',
  },
  features: {
    title: 'Todo lo que Necesitas para Explorar USFans en un Solo Lugar',
    subtitle: 'Un punto de partida claro para vendedores, productos, QC, envío y seguridad.',
    seller: {
      title: 'Descubrir Vendedores',
      desc: 'Encuentra recursos organizados de vendedores y compara información relevante.',
    },
    product: {
      title: 'Descubrir Productos',
      desc: 'Explora categorías populares de productos y recursos relacionados de la spreadsheet.',
    },
    qc: {
      title: 'Recursos QC',
      desc: 'Aprende cómo la información y las fotos de QC ayudan a evaluar productos.',
    },
    shipping: {
      title: 'Guías de Envío',
      desc: 'Entiende los métodos, costes y consideraciones importantes del envío.',
    },
    safety: {
      title: 'Recursos de Seguridad',
      desc: 'Aprende a evaluar enlaces, vendedores, pagos y riesgos de compra.',
    },
    updated: {
      title: 'Recursos Actualizados',
      desc: 'Mantén la información importante organizada y fácil de volver a consultar.',
    },
  },
  article: {
    title: 'Guía de USFans Spreadsheet',
    subtitle:
      'Lee nuestra guía detallada para entender vendedores, productos, QC, envío y seguridad antes de comprar.',
    cardTitle: 'USFans Spreadsheet: La Guía Completa',
    cardDesc:
      'Descubre qué es una USFans spreadsheet, cómo encontrar vendedores y productos, y cómo comprar con seguridad.',
    readMore: 'Leer la guía completa',
    readGuide: 'Abrir la guía',
    minutes: '7 min de lectura',
    related: 'Guías Relacionadas',
    tableTitle: 'Tabla de Referencia Rápida',
    pros: 'Ventajas',
    cons: 'Desventajas',
    notFound: 'Guía no encontrada',
  },
  articleSection: {
    title: 'Guías y Recursos de USFans',
    subtitle:
      'Explora nuestra biblioteca de guías independientes sobre vendedores, productos, QC, envío, cupones, seguridad y más.',
  },
  faq: {
    title: 'Preguntas Frecuentes',
    subtitle: 'Respuestas rápidas a las preguntas más comunes sobre la USFans spreadsheet.',
    q1: {
      q: '¿Qué es una USFans spreadsheet?',
      a: 'Una USFans spreadsheet es una tabla organizada que reúne vendedores, productos, categorías, información QC y notas de envío en un solo lugar.',
    },
    q2: {
      q: '¿USFansSheet.link está afiliado con USFans?',
      a: 'No. USFansSheet.link es un recurso informativo independiente y no está necesariamente afiliado con USFans.',
    },
    q3: {
      q: '¿Cómo encuentro productos?',
      a: 'Usa el directorio de categorías de esta página para ir a zapatos, sudaderas, camisetas y otras categorías en el sitio web principal.',
    },
    q4: {
      q: '¿Debo revisar el QC antes de comprar?',
      a: 'Sí. Revisar las fotos y notas de QC puede ayudarte a confirmar que un artículo coincide con su descripción antes del envío.',
    },
  },
  cta: {
    title: '¿Listo para Explorar la USFans Spreadsheet?',
    subtitle:
      'Empieza con el hub de la spreadsheet, compara los recursos disponibles y encuentra la información que necesitas antes de continuar al sitio web principal.',
    button1: 'Abrir USFans Spreadsheet',
    button2: 'Comprar Ahora',
  },
  footer: {
    tagline:
      'Un hub de recursos independiente para descubrir vendedores, productos, QC e información de compra de USFans.',
    disclaimer:
      'USFansSheet.link es un recurso informativo independiente y no está necesariamente afiliado ni respaldado por USFans. La información puede cambiar; verifica los detalles en fuentes oficiales.',
    categories: 'Categorías',
    resources: 'Recursos',
    guide: 'Guía de la Spreadsheet',
    home: 'Inicio',
    backToTop: 'Volver arriba',
    rights: 'Todos los derechos reservados.',
  },
  categoryNames: {
    shoes: 'Zapatos',
    hoodies: 'Sudaderas / Jerséis',
    tshirts: 'Camisetas',
    jackets: 'Chaquetas',
    pants: 'Pantalones / Pantalones cortos',
    headwear: 'Gorros',
    sets: 'Conjuntos',
    underwear: 'Ropa interior',
    jersey: 'Camiseta deportiva',
    accessories: 'Accesorios',
    bags: 'Bolsos',
    belts: 'Cinturones',
    perfumes: 'Perfumes',
    other: 'Otros',
  },
};